import * as React from "react"
const Pencil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    transform="rotate(90)"
    viewBox="0 0 411.765 411.765"
    {...props}
  >
    <path
      d="M397.37 52.855c5.86 5.86 5.86 15.36 0 21.21l-33.6 33.6-29.84-29.83-29.83-29.84 33.6-33.6c5.85-5.86 15.35-5.86 21.21 0l38.46 38.46z"
      style={{
        fill: "#f2d59f",
      }}
    />
    <path
      d="M363.77 107.665 92.95 378.485l-29.83-29.83 270.81-270.82z"
      style={{
        fill: "#8ecac1",
      }}
    />
    <path
      d="m304.1 47.995 29.83 29.84-270.81 270.82h-.01l-29.83-29.84z"
      style={{
        fill: "#ff7124",
      }}
    />
    <path
      d="m92.95 378.485-60.34 16.94-16.27-16.27 16.94-60.34 29.83 29.84h.01z"
      style={{
        fill: "#e6b263",
      }}
    />
    <path d="M32.61 395.425 10 401.765l6.34-22.61z" />
    <path
      d="M32.605 405.428c-4.37 0-8.383-2.886-9.623-7.299-1.493-5.317 1.608-10.838 6.925-12.331l60.34-16.94c5.317-1.494 10.838 1.607 12.331 6.925 1.493 5.317-1.608 10.838-6.925 12.331l-60.34 16.94c-.903.253-1.814.374-2.708.374zM16.346 389.158a9.99 9.99 0 0 1-2.708-.375c-5.317-1.493-8.417-7.014-6.925-12.331l16.94-60.34c1.493-5.317 7.017-8.414 12.331-6.925 5.317 1.493 8.417 7.014 6.925 12.331l-16.94 60.34c-1.24 4.413-5.254 7.3-9.623 7.3zM63.12 358.655a9.968 9.968 0 0 1-7.071-2.929c-3.905-3.905-3.906-10.237 0-14.142l270.81-270.82c3.906-3.905 10.236-3.906 14.143-.001 3.905 3.905 3.905 10.237 0 14.142l-270.81 270.82a9.966 9.966 0 0 1-7.072 2.93z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M92.95 388.485a10.001 10.001 0 0 1-7.071-2.929L56.313 355.99a8.557 8.557 0 0 1-.275-.265l-29.83-29.84c-3.904-3.905-3.904-10.236.001-14.141l270.82-270.82c3.906-3.905 10.236-3.905 14.143 0 3.905 3.905 3.905 10.237 0 14.143l-263.75 263.75 22.498 22.505c.092.086.184.173.273.263l22.758 22.759L356.7 100.595c3.906-3.905 10.236-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.143l-270.82 270.82a10.007 10.007 0 0 1-7.072 2.927z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M363.77 117.665a9.969 9.969 0 0 1-7.07-2.928l-59.672-59.672c-3.904-3.905-3.903-10.236.001-14.141l33.601-33.6C335.342 2.604 341.62 0 348.301 0c6.679 0 12.957 2.601 17.68 7.324l38.461 38.461c4.723 4.723 7.323 11.001 7.323 17.679 0 6.681-2.603 12.96-7.329 17.678l-33.595 33.594a9.974 9.974 0 0 1-7.071 2.929zm-45.529-69.668 45.528 45.528 26.53-26.53a4.965 4.965 0 0 0 1.466-3.53c0-.773-.191-2.262-1.466-3.538l-38.46-38.46a4.983 4.983 0 0 0-3.538-1.466c-.772 0-2.256.19-3.523 1.46l-26.537 26.536zM10.001 411.765a10.001 10.001 0 0 1-9.629-12.7l6.34-22.61a10.002 10.002 0 0 1 16.7-4.372l16.27 16.27a10 10 0 0 1-4.372 16.7l-22.61 6.34a9.943 9.943 0 0 1-2.699.372z"
      style={{
        fill: "#5e2a41",
      }}
    />
  </svg>
)
export default Pencil
